import { useParams } from 'react-router-dom';
import useCompetitionProblems from 'hooks/useCompetitionProblems';
import Loading from 'components/system/Loading/Loading';
import CompetitionNotion from 'components/pages/Competition/CompetiotionNotion';

const Problems = () => {
  const { id: competitionId } = useParams();

  const { problemsNotionLink, isLoading } = useCompetitionProblems(competitionId);

  if (isLoading) return <Loading />;

  return <CompetitionNotion link={problemsNotionLink} />;
};

export default Problems;
